export default __webpack_public_path__ + "static/media/B_minor.65ff475d.jpg";